export default __webpack_public_path__ + "static/media/ga-009.b518d3ec.jpg";